import styled from 'styled-components';

export default styled.h3`
	font-family: ${({ theme }) => theme.fonts.slabBold};
	font-size: ${({ theme }) => theme.fontSizes.m};
	color: ${({ textColor }) => textColor ? textColor : ({ theme }) => theme.colors.AGCOBlack};
`;
